<!--UlBasicSchool:学校的考试概况细分表 2023/11/20 19:15:45 YuAng-->

<template>
  <div class="basic-school">
    <div class="basic-table-left">
      <p :class="hiddenClass" class="table-th">
        统计单位
      </p>
      <p :class="hiddenClass">
        有效分（总分有效分{{ toPointFixed(school[lowerKey + 'Score']) }}）
      </p>
      <div class="table-left-aside">
        <div class="left-left">
          <span>{{ isFirst ? '本校' : school.schoolName }}</span>
          <span>统计人数 {{ school.studentNum }}</span>
          <span>上线人数 {{ school['over' + lineKind + 'Num'] }}</span>
          <span>上线比例 {{ school[lowerKey + 'ScoreRate'] }}</span>
        </div>
        <div class="left-right">
          <p>单上线人数</p>
          <p>双上线人数</p>
          <p>贡献率</p>
          <p>命中率</p>
          <p>
            总分上线人数
            <el-tooltip class="item" effect="dark" content="选了该科目，且总分上线的学生数目" placement="top">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </p>
        </div>
      </div>
    </div>
    <div class="basic-table-right">
      <p class="table-right-subject" v-for="item in school.subjects" :key="item.subject + item.schoolId">
        <span :class="hiddenClass" class="table-th">{{ item.subjectName }}</span>
        <span :class="hiddenClass">
          {{ toPointFixed(item[lowerKey + 'Score']) }}
        </span>
        <span>
          {{ item['over' + lineKind + 'Num'] }}
        </span>
        <span>
          {{ item['twiceOver' + lineKind + 'Num'] }}
        </span>
        <span>
          {{ item[lowerKey + 'ContributionRate'] }}
        </span>
        <span>
          {{ item[lowerKey + 'HitRate'] }}
        </span>
        <span>
          {{ item['overTotal' + lineKind + 'Num'] }}
        </span>
      </p>
    </div>
  </div>
</template>
<script>
import util from '@/utils/util'
export default {
  name: 'UlBasicSchool',
  props: {
    school: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isFirst: {
      type: Boolean,
      default: false
    },
    lineKind: {
      type: String,
      default: 'First' // Second
    }
  },
  computed: {
    lowerKey: function () {
      return this.lineKind.toLowerCase()
    },
    hiddenClass: function () {
      return { 'x-placeholder': this.isFirst === false }
    }
  },
  methods: {
    toPointFixed: util.toPointFixed,
  }
}
</script>

<style scoped>
.basic-school {
  display: flex;
  border-left: 1px solid #EBEEF5;
  border-top: 1px solid #EBEEF5;
  border-right: 1px solid #EBEEF5;
  text-align: center;
  font-size: 12px;
}

.basic-school:last-child {
  border-bottom: 1px solid #EBEEF5;
}

.basic-school p {
  border-bottom: 1px solid #EBEEF5;
  height: 30px;
  line-height: 30px;
}

.basic-table-left {
  width: 300px;
  border-right: 1px solid #EBEEF5;
}

.basic-table-right {
  flex: 1;
  display: flex;
}

.table-left-aside {
  display: flex;
}

.left-left {
  width: 148px;
  border-right: 1px solid #EBEEF5;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 4px;
}

.left-right {
  flex: 1;
}

.left-right p:last-child {
  border: none;
}

.table-right-subject {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.table-right-subject span {
  border-right: 1px solid #EBEEF5;
  border-bottom: 1px solid #EBEEF5;
  min-width: 70px;
}

.table-right-subject span:last-child {
  border-bottom: none;
}

.table-right-subject:last-child span {
  border-right: none;
}

.x-placeholder {
  visibility: hidden;
  height: 0 !important;
  border: none !important;
}


.basic-school ::v-deep .el-icon-question {
  font-size: 14px;
  color: #666;
}

.table-th {
  background-color: #f7f7f7;
  font-weight: bold;
}
</style>